import * as React from 'react';
import { ElementLoader } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { DeleteRowsComponentProps } from 'app/area/indicator-factors/types';

export const DeleteRowsModal: React.FC<DeleteRowsComponentProps> =
  ({ fetchingDeleteRows, numberOfResults, translation, onClose, save }: DeleteRowsComponentProps) =>
    <ModalWrapper
      headerTitle={`${translation.delete_rows_description} (${numberOfResults})`}
      btnTitle={translation.delete_rows_description}
      btnCancelTitle={translation.cancel}
      onClose={onClose}
      onDone={save}
      closeOnDone={false}
      largeSize={false}
      isCancelDisabled={fetchingDeleteRows}
      isDisabled={fetchingDeleteRows}
      canCloseOnBackground={!fetchingDeleteRows}
      canCloseOnXButton={!fetchingDeleteRows}>

      {fetchingDeleteRows
        ? <ElementLoader />
        : <div>
          {replaceTemplateString(
            translation.confirm_delete_rows,
            numberOfResults
          )}
        </div>}
    </ModalWrapper>;
